import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I wish this existed",
  "description": "",
  "published": "2012-03-23T00:00:00.000Z",
  "redirect_from": ["/blog/i-wish-this-existed/swizec/4045"],
  "categories": "Code, editor, Highlighter, HTML, Programming, Syntax, Syntax highlighting, Turbo Pascal, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Just realized 90% of my blogposts rape the word "actually".`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/181674782339772416"
      }}>{`March 19, 2012`}</a></blockquote>
    <p>{`This happens because not a single writing tool can tell me `}<em parentName="p">{`Hey you, yes you, you're using too many `}{`[filler words]`}{`(`}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Filler"
        }}>{`http://en.wikipedia.org/wiki/Filler`}</a></em>{`%28linguistics%29 "Filler (linguistics)"), yo!`}{`_`}</p>
    <p>{`Ever since the 1990's programmers have been using a key piece of technology. An ubiquitous piece of tech that exists in even the most trivial of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Code",
        "title": "Code"
      }}>{`code`}</a>{` editors, something that makes the life of a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Programmer",
        "title": "Programmer"
      }}>{`coder`}</a>{` survivable.`}</p>
    <h2 {...{
      "id": "syntax-highlighting"
    }}>{`Syntax highlighting!`}</h2>
    <p>{`This is what code looked like before `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Syntax",
        "title": "Syntax"
      }}>{`syntax`}</a>{` highlighting. Working with this wasn't impossible ... the longest piece of code I came up with was probably upwards of 4000 lines of very horrible code ... hey, I was 12, cut me some slack.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/turbo_pascal.png",
        "alt": "Turbo Pascal 6",
        "title": "Turbo Pascal 6"
      }}></img></p>
    <p>{`I still remember the incredible joy that came with installing Turbo Pascal 7. `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Syntax_highlighting",
        "title": "Syntax highlighting"
      }}>{`Syntax Highlighting`}</a>{` baby! No seriously, the code was suddenly `}<em parentName="p">{`better`}</em>{`.`}</p>
    <p>{`Life in general was `}<em parentName="p">{`better`}</em>{`. I would compare `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Quality_of_life",
        "title": "Quality of life"
      }}>{`quality of life`}</a>{` before and after syntax highlighting to losing one's virginity. It is literally `}<em parentName="p">{`that`}</em>{` awesome.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/turbo_pascal_7_scholl_pack_13_640966.png",
        "alt": "Turbo Pascal 7",
        "title": "Turbo Pascal 7"
      }}></img></p>
    <p>{`I remember spending a lot of time just tweaking the highlighter settings, making sure everything looked just right. A well set up syntax highlighter makes you feel at home :)`}</p>
    <p>{`These days I no longer pay much attention to syntax highlighting, I just take it for granted. If a file looks wrong in `}<a parentName="p" {...{
        "href": "http://www.gnu.org/software/emacs",
        "title": "Emacs"
      }}>{`Emacs`}</a>{`, you simply go on the internets, download the appropriate mode and voila, code looks good again.`}</p>
    <h2 {...{
      "id": "natural-language-syntax-highlighting"
    }}>{`Natural language syntax highlighting`}</h2>
    <p>{`Coding isn't all I do anymore, though A lot of my time is spent `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/on-writing-every-day/swizec/3058"
      }}>{`writing every day`}</a>{`. My editors though ... are kind of lame.`}</p>
    <p>{`When writing English my "code" still looks like it was 1994:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/Screen-Shot-2012-03-23-at-11.57.31-AM.png",
        "alt": "Distractionless writing",
        "title": "Distractionless writing"
      }}></img></p>
    <p>{`Writing without distractions is all fine and good, but syntax highlighting isn't a distraction! It's helpful!`}</p>
    <p>{`What if instead of a cold hard piece of text staring back at me from the editor, there was something like this instead:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/Screen-Shot-2012-03-23-at-12.34.24-PM.png",
        "alt": "English syntax highlighting",
        "title": "English syntax highlighting"
      }}></img></p>
    <p>{`This is just a simple mockup I put together in html in about 20 minutes. Syntax highlighting on the level of words`}</p>
    <ul>
      <li parentName="ul">{`verbs are pink`}</li>
      <li parentName="ul">{`pronouns are green`}</li>
      <li parentName="ul">{`nouns are blue`}</li>
      <li parentName="ul">{`errors have a red background`}</li>
    </ul>
    <p>{`Not sure how visible it is, but when editing a sentence, it would be useful for the start and end of it to be highlighted with a light blue hue ... just like parenthesis matching when coding!`}</p>
    <p>{`It would be really cool if syntax highlighting for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Natural_language",
        "title": "Natural language"
      }}>{`natural languages`}</a>{` went beyond words and onto concepts, where it isn't just the noun that turns blue, but all adjectives attached to it would get a blue-ish background.`}</p>
    <p>{`That would help `}<em parentName="p">{`incredibly`}</em>{` when it comes to overloading.`}</p>
    <h2 {...{
      "id": "who-could-use-this"
    }}>{`Who could use this?`}</h2>
    <p>{`If natural languages were a bit simpler, we'd already have syntax `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Highlighter",
        "title": "Highlighter"
      }}>{`highlighters`}</a>{` ... or maybe nobody's thought of this before?`}</p>
    <p>{`I for one do enough writing that I would pay for something like this. Make it a wordpress plugin or something ... or an emacs mode. I don't care, I want it!`}</p>
    <p>{`Hopefully I'm not the only person who needs this, there is a whole market of book and magazine editors, professional writers, journalists and so on who could benefit from something like this.`}</p>
    <p>{`However, all of those people will never `}<em parentName="p">{`ask`}</em>{` for syntax highlighting, I doubt many of them even realize such a concept exists.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/webdevs-you-have-no-idea-how-much-you-know/swizec/3891"
        }}>{`Webdevs, you have no idea how much you know`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://alexanderle.com/blog/2012/03/17/syntax-highlighting-with-gvim.html"
        }}>{`Add Syntax Highlighting To Your Blog With VIM`}</a>{` (alexanderle.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://briancarper.net/blog/556/clojure-syntax-highlighting-via-syntaxhighlighter"
        }}>{`Clojure syntax highlighting via SyntaxHighlighter`}</a>{` (briancarper.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://weblogs.sdn.sap.com/pub/wlg/28805"
        }}>{`How-to use syntax highlighting using Notepad++ for SAP NetWeaver Identity Management scripts`}</a>{` (weblogs.sdn.sap.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://kungfuwit.wordpress.com/2012/02/22/syntax-highlighting-for-code-blocks-in-madcap-flare-with-prettify/"
        }}>{`Syntax highlighting of code blocks with Prettify`}</a>{` (kungfuwit.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a7e90941-a919-4af3-8fc0-ae8f05b19449",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      